export const AUTH_RECEIVED = 'AUTH_RECEIVED';
export const SEND_CREDENTIALS = 'SEND_CREDENTIALS';
export const CLEAR_STORES = 'CLEAR_STORES';
export const UPDATE_INFO_BOX = 'UPDATE_INFO_BOX';
export const CLEAR_INFO_BOX_MESSAGE = 'CLEAR_INFO_BOX_MESSAGE';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const SEND_CONFIRMATION_LINK = 'SEND_CONFIRMATION_LINK';
export const SEND_SECONDARY_EMAIL_CONFIRMATION = 'SEND_SECONDARY_EMAIL_CONFIRMATION';
export const DISASSOCIATE_SECONDARY_EMAIL = 'DISASSOCIATE_SECONDARY_EMAIL';
export const RESET_PASSWORD_WITH_TOKEN = 'RESET_PASSWORD_WITH_TOKEN';
export const ADMIN_SIGNIN = 'ADMIN_SIGNIN';
export const CONFIRM_SECONDARY_EMAIL = 'CONFIRM_SECONDARY_EMAIL';
export const CONFIRM_SIGNIN_EMAIL = 'CONFIRM_SIGNIN_EMAIL';
export const CONFIRM_DISASSOCIATE_SECONDARY = 'CONFIRM_DISASSOCIATE_SECONDARY';



// WEBPACK FOOTER //
// ./src/app/stores/sign-in/sign-in-constants.js